import { jsx as _jsx } from "react/jsx-runtime";
import { Home } from '@pages/home';
export const routes = [
    {
        path: '/',
        element: _jsx(Home, {}),
    },
];
